import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_viewer/viewer-texto";

export const Route = createFileRoute("/_authenticated/viewer-texto")({
  validateSearch: (search: Record<string, unknown>) => ({
    titulo: typeof search.titulo === "string" ? search.titulo : "Visualizador de texto",
    conteudo: typeof search.conteudo === "string" ? search.conteudo : "",
  }),
  head: () => ({
    meta: [
      { title: "Visualizador de texto — Milky Moo Palmares" },
      { name: "description", content: "Visualização de conteúdo de auditoria." },
    ],
  }),
  component: PaginaRota,
});
